/* global Vue, VeeValidate, VueI18n, CONTEXT */

import { Notifications, setSuccessAndStopLoading, setErrorAndStopLoading, startLoading } from './components/Notifications'
import CountriesDropdown from './components/CountriesDropdown'
import PhoneNumber from './components/PhoneNumber'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'
import '../validation-rules'

const i18n = CreateI18n(messagesSpecific)

const WeddingsApp = Vue.createApp({
  name: 'WeddingsApp',
  components: { CountriesDropdown, Notifications, PhoneNumber },
  template: '#weddings-app-template',

  setup () {
    const { t } = VueI18n.useI18n()
    const form = Vue.reactive({
      musicType: [],
      properties: {
        rovinj: [],
        zagreb: [],
        dubrovnik: [],
      },
    })
    const countryPrefix = Vue.ref('')
    const formName = 'Weddings'
    const formErrors = Vue.reactive({})
    const validationSchema = {
      firstName: 'required|min:2',
      lastName: 'required|min:2',
      address: 'required',
      postcode: 'required',
      city: 'required',
      country: 'required',
      email: 'required|email',
      mobile: 'required|phone',
      contactType: 'reqAtLeastOne',
      weddingDate: 'required',
      weddingDateAlt: 'required',
      noGuests: 'reqNumber',
    }

    const { handleSubmit, handleReset, errors, isSubmitting } = VeeValidate.useForm({
      validationSchema,
      initialValues: {
        contactType: [],
      },
    })

    const fieldRefs = Vue.reactive({})
    Object.keys(validationSchema).forEach((field) => {
      const fieldObj = VeeValidate.useField(field, undefined, {
        validateOnValueUpdate: false,
      })
      form[field] = fieldObj.value
      formErrors[field] = fieldObj.errorMessage
      fieldRefs[field] = fieldObj
    })

    Vue.watch(isSubmitting, () => {
      if (Object.keys(errors).length > 0) {
        const highlight = Array.from(document.querySelectorAll('.field-error')).filter(er => er.innerHTML)[0] || null
        if (highlight) { highlight.parentNode.scrollIntoView({ behavior: 'smooth' }) }
      }
    })

    const sendForm = handleSubmit(async () => {
      startLoading(formName)
      try {
        const hasSelectedProperties = Object.values(form.properties).some(arr => arr.length > 0)

        if (hasSelectedProperties) {
          for (const key in form.properties) {
            if (Object.hasOwnProperty.call(form.properties, key)) {
              const element = form.properties[key]
              if (element.length > 0) {
                const newForm = JSON.parse(JSON.stringify(form))
                newForm.properties = element
                const response = await fetch('/', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: `${new URLSearchParams(newForm).toString()}&form-name=${formName}${key.toUpperCase()}`,
                })
                if (!response.ok) {
                  throw new Error(response.statusText)
                }
              }
            }
          }
        } else {
          // When no properties are selected, send inquiry to default - ROVINJ (MICE email)
          // This fallback ensures all inquiries are handled, even if the user does not select a specific property.
          const newForm = JSON.parse(JSON.stringify(form))
          delete newForm.properties
          const response = await fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `${new URLSearchParams(newForm).toString()}&form-name=${formName}ROVINJ`,
          })
          if (!response.ok) {
            throw new Error(response.statusText)
          }
        }

        handleReset()
        form.musicType = []
        form.properties = {
          rovinj: [],
          zagreb: [],
          dubrovnik: [],
        }
        form.useAccommodation = ''
        form.comment = ''
        setSuccessAndStopLoading({ details: t('formSubmitSuccess') })
      } catch (err) {
        setErrorAndStopLoading(err)
      }
    })

    function triggerFatalError () {
      setErrorAndStopLoading({ code: 'phobsError3' })
    }

    function validateField (field) {
      fieldRefs[field].validate()
    }

    return {
      form,
      formErrors,
      sendForm,
      CONTEXT,
      triggerFatalError,
      validateField,
      countryPrefix,
    }
  },
})

const appElement = document.getElementById('weddings-app')

if (appElement) {
  WeddingsApp.use(i18n)
  WeddingsApp.mount(appElement)
}
